import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { SiteMonitorCamerasState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: SiteMonitorCamerasState = getDefaultState();

const namespaced: boolean = true;

export const siteMonitorCameras: Module<SiteMonitorCamerasState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
